import { computed } from 'vue';
import store from '@/store';
import { message } from '@/utils/js/initVariable';
import { dragPopupComCreate } from '@/utils/js/leafletUtils';
import { shootingAreaAnalysis } from '@/api/Region';
import ClueDetection from '@/views/ShootDataView/ClueDetection';

/**
 * 线索区识别 Worker/请求
 * @param {Object} props - 组件 props
 * @param {Ref} loadProp - loading 属性名
 */
export function useClueArea(props, loadProp) {
  const clueAreaList = computed(() => store.getters['clueAreaList']);

  // 线索区popup
  const cluePopupInit = (data, updateList) => {
    const bounds = props.layer.getBounds(),
      latlng = bounds.getNorthEast();
    const { app, group } = dragPopupComCreate(latlng)(ClueDetection, {
      list: data,
      updateList,
      onClose: () => {
        if (group) {
          props.layerGroup.removeLayer(group);
          app?.unmount();
        }
      }
    });

    props.layerGroup.addLayer(group);

    props.layer.once({
      remove: () => {
        props.layerGroup.removeLayer(group);
        app?.unmount();
      }
    })
  }

  // 线索区识别
  const clueAdd = (btn) => {
    if (clueAreaList.value.length === 0) {
      message('暂无可识别的线索区', 2);
      return;
    }
    btn[loadProp.value] = true;
    const geojson = props.layer.toGeoJSON();
    const worker = new Worker(new URL('../worker/clueArea.js', import.meta.url));
    const workerEnd = () => {
      btn[loadProp.value] = false;
      worker.terminate();
    }

    worker.postMessage({
      data: clueAreaList.value.map(e => {
        return {
          ...e, layer: undefined,
        }
      }),
      geojson,
    });
    worker.onmessage = (event) => {
      const { result } = event.data;
      if (result.length === 0) {
        message('暂无可识别的线索区', 2);
        workerEnd();
        return;
      }
      if (!(result.length > 1)) {
        message('选择的线索区不得小于1', 2);
        workerEnd();
        return;
      }
      shootingAreaAnalysis({
        polygonList: result,
      }).then(res => {
        if (res.data.code === 1004) {
          if (!res.data.dataList) {
            message('暂未识别出有效区域', 2);
            return;
          }
          cluePopupInit(res.data.dataList, res.data.updateDataList || []);
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        workerEnd();
      });
    }
    worker.onerror = (err) => {
      console.log(err);
      workerEnd();
    }
  }

  return { clueAreaList, clueAdd };
}
